import { Modal, Button, Badge } from 'react-bootstrap';
import MDEditor from '@uiw/react-md-editor';
import type { ManualResponse } from '../../../infrastructure/AIAgentRegistryClient';
import { formatDate } from '../../../utils/dateUtils';

interface ManualDetailModalProps {
  show: boolean;
  manual: ManualResponse | null;
  onHide: () => void;
  onEdit: () => void;
}

export const ManualDetailModal = ({ show, manual, onHide, onEdit }: ManualDetailModalProps) => {
  if (!manual) return null;

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {manual.name}
          <Badge bg="secondary" className="ms-2">{manual.category}</Badge>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <strong>Description:</strong>
          <p className="text-muted">{manual.description}</p>
        </div>

        {manual.bestPracticeExecutionIds && manual.bestPracticeExecutionIds.length > 0 && (
          <div className="mb-3">
            <strong>Best Practice Execution IDs:</strong>
            <div>
              {manual.bestPracticeExecutionIds.map((id) => (
                <Badge key={id} bg="info" className="me-1">{id}</Badge>
              ))}
            </div>
          </div>
        )}

        {manual.manualMarkdown && (
          <div className="mb-3">
            <strong>Manual Markdown:</strong>
            <div data-color-mode="light" className="mt-2 border rounded p-2">
              <MDEditor.Markdown source={manual.manualMarkdown} />
            </div>
          </div>
        )}

        <div className="mb-3">
          <small className="text-muted">Updated: {formatDate(manual.updatedAt)}</small>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Close</Button>
        <Button variant="primary" onClick={onEdit}>Edit</Button>
      </Modal.Footer>
    </Modal>
  );
};

